/* eslint-disable */
export default function superUserValidation(e, msgContainer, key) {
        msgContainer[key] = [];
        msgContainer['isError'] = false;
        let insertedData = e.target.value;
        const passwordInput = document.getElementById('password').value;
        let respass = /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^\da-zA-Z]).*\S{8,})$/.test(insertedData);
        let res = /^[a-zA-Z0-9\s]*$/.test(insertedData);

        switch (key) {
            case 'name':
                validateName(msgContainer, insertedData, res);
                break;
            case 'password':
                validatePassword(msgContainer, insertedData, respass);
                break;
            case 'password_confirmation':
                validatePasswordConfirmation(msgContainer, insertedData, passwordInput, respass);
                break;
            default:
                validateDefaultField(msgContainer, insertedData);
                break;
        }

        return msgContainer;
    }

    function validateName(msgContainer, data, isValid) {
        if (!isValid) {
            msgContainer['isError'] = true;
            msgContainer['name'].push('* Name Must be Alpha With Space Only');
        } else if (data.length > 40) {
            msgContainer['isError'] = true;
            msgContainer['name'].push('* Name Must be less than 40 characters');
        }
    }

    function validatePassword(msgContainer, data, isValid) {
        if (!isValid) {
            msgContainer['isError'] = true;
            msgContainer['password'].push('* Password Must Be at least 8 characters characters, uppercase, lowercase, number, special character ');
        } else if (data.length > 40) {
            msgContainer['isError'] = true;
            msgContainer['password'].push('* Password Must be less than 40 characters');
        }
    }

    function validatePasswordConfirmation(msgContainer, data, passwordInput, isValid) {
        if (!isValid) {
            msgContainer['isError'] = true;
            msgContainer['password_confirmation'].push('* Password Must Be at least 8 characters characters, uppercase, lowercase, number, special character ');
        } else if (data.length > 40) {
            msgContainer['isError'] = true;
            msgContainer['password_confirmation'].push('* Password Must be less than 40 characters');
        } else if (data !== passwordInput) {
            msgContainer['isError'] = true;
            msgContainer['password_confirmation'].push('* Password confirmation does not match password');
        }
    }

    function validateDefaultField(msgContainer, data) {
        if (data.length < 1) {
            msgContainer['isError'] = true;
            msgContainer.default.push('*Required');
        } else if (data.length > 40) {
            msgContainer['isError'] = true;
            msgContainer.default.push('* Field Must be less than 40 characters');
        }
    }
